export const LOGIN = "common/log-in";
export const GET_INTERFACE_LANGUAGE = "preferences/get-interface-language";
export const SET_INTERFACE_LANGUAGE = "preferences/set-interface-language";
export const GET_SHIPPING_COUNTRIES = "dictionary/get-all-from-countries";
export const GET_ADDRESS_FOR_SHOPPING = "dictionary/get-address-for-shopping";
export const GET_COUNTRIES = "dictionary/get-countries";
export const GET_CITIES = "dictionary/get-cities";
export const GET_REGIONS = "dictionary/get-regions";
export const GET_GOODS_CATEGORIES = "dictionary/get-goods-categories";
export const GET_CURRENCIES = "dictionary/get-currencies";
export const GET_SHIPPING_RATES = "dictionary/get-shipping-rates";
export const GET_SHIPPING_PROVIDERS = "dictionary/get-shipping-providers";
export const GET_DESTINATION_COUNTRIES = "dictionary/get-destination-countries";
export const GET_SHIPMENT_LIST = "shipment/get-shipment-list";
export const CREATE_SHIPMENT = "shipment/create-shipment";
export const DELETE_SHIPMENT = "shipment/delete-shipment";
export const GET_DELIVERY_ADDRESSES_FOR_SHIPMENT =
  "shipment/get-available-delivery-addresses-for-shipment";
export const GET_CUSTOM_ADDRESSES_FOR_SHIPMENT =
  "shipment/get-available-addresses-for-recipient-for-shipment";
export const GET_ADDRESSES_LIST = "address/get-address-list";
export const GET_DATA_ABOUT_ADDRESS = "address/get-data-about-address";
export const GET_DEFAULT_ADDRESS_DELIVERY =
  "address/get-default-address-delivery";
export const SET_DEFAULT_ADDRESS_DELIVERY =
  "address/set-default-address-delivery";
export const CREATE_CUSTOM_ADDRESS = "address/create-custom-address";
export const UPDATE_CUSTOM_ADDRESS = "address/update-custom-address";
export const CREATE_DELIVERY_ADDRESS = "address/create-delivery-address";
export const UPDATE_DELIVERY_ADDRESS = "address/update-delivery-address";
export const DETELE_ADDRESS = "address/delete-address";
export const MAKE_DELIVERY_REQUEST = "shipment/make-delivery-request";
export const CANCEL_INSURANCE_SERVICE_FOR_SHIPMENT =
  "shipment/cancel-insurance-service-for-shipment";
export const GET_ALL_SHIPMENTS_SERVICES =
  "dictionary/get-all-shipments-services";
export const GET_DEFAULT_SERVICES = "preferences/get-default-services";
export const SET_DEFAULT_SERVICES = "preferences/set-default-services";
export const IS_FULL_NECESSARY_DATA_OF_CLIENT =
  "address/get-is-full-necessary-data-of-client";
export const GET_NECESSARY_DATA_OF_CLIENT =
  "address/get-necessary-data-of-client";
export const UPDATE_NECESSARY_DATA_OF_CLIENT =
  "address/update-necessary-data-of-client";
export const GET_SHIPMENT_TYPES = "dictionary/get-shipments-types";
export const GET_PRODUCT_SUBCATEGORIES = "dictionary/get-product-subcategory";
export const GET_PRODUCT_TYPES = "dictionary/get-product-types";
export const GET_ONLINE_SHOPS = "dictionary/get-online-shops";
export const VIEW_PARCEL = "shipment/get-data-about-shipment-for-view";
export const GET_DATA_TO_CREATE_PARCEL =
  "shipment/get-data-about-shipment-for-create-shipment";
export const GET_DATA_TO_EDIT_PARCEL =
  "shipment/get-data-about-shipment-for-edit-shipment";
export const UPDATE_PARCEL = "shipment/update-shipment";
export const GET_SHIPMENT_INVOICE_PHOTO = "shipment/get-shipment-invoice-photo";
export const UPDATE_SHIPMENT_INVOICE_PHOTO =
  "shipment/update-shipment-invoice-photo";
export const DELETE_SHIPMENT_INVOICE_PHOTO =
  "shipment/delete-shipment-invoice-photo";
export const GET_STATUSES_PARAMS =
  "preferences/get-statuses-params-email-notification";
export const UPDATE_STATUSES_PARAMS =
  "preferences/update-status-params-email-notification";
export const GET_LAST_SHIPMENT_STATUSES = "shipment/get-last-shipment-statuses";
export const GET_BASIC_USER_DATA = "common/get-basic-user-data";
export const GET_BALANCE_INFO = "payment/get-balance-short-info";
export const GET_TRANSACTION_HISTORY = "payment/get-transaction-history";

//Registration services
export const SIGN_UP = "common/sign-up";
export const CHECK_EMAIL_REGISTRATION = "common/check-email-for-registration";
export const CHECK_PHONE_REGISTRATION = "common/check-phone-for-registration";
export const CHECK_PASSWORD_REGISTRATION =
  "common/check-password-for-registration";
export const CHECK_PIN_FL_REGISTRATION = "common/check-pin-fl-for-registration";
export const CHECK_PERSONAL_ID_REGISTRATION =
  "common/check-personal-id-for-registration";
export const CHECK_EXISTING_TRACK_CODE = "shipment/get-check-exists-track-code";

export const GET_PROMOCODE_LIST = "promocode/get-promocode-list";
export const APPLY_PROMOCODE = "promocode/apply-promocode";
export const CHECK_PROMOCODE = "promocode/check-promocode-available";

export const CHANGE_PASSWORD = "common/change-password";
export const START_RESET_PASSWORD = "common/start-reset-password";

// payments
export const GET_PAYMENT_PROVIDERS = "payment/get-bank-payment-providers";
export const GET_PAYMENT_URL = "payment/get-bank-payment-url-for-pay";
export const GET_COMMISSION_FOR_REFILL =
  "payment/get-commission-for-refill-account";
export const GET_AMOUNT_TO_PAY_SHIPMENTS =
  "payment/get-amount-to-pay-shipments";
export const START_PAY_SHIPMENT_PROCESS = "payment/start-pay-shipment-process";
export const FINAL_PAY_SHIPMENT = "payment/final-pay-shipment-process";
export const ADD_NEW_BUY_REQUEST = "common/add-new-buy-request";
export const GET_MAIN_INFO_DATA = "address/get-main-info-data";
export const UPDATE_MAIN_INFO_DATA = "address/update-main-info-data";
export const GET_ALL_BUY_REQUESTS = "common/get-all-buy-requests";
export const RESET_PASSWORD_BY_TOKEN = "common/change-password-by-reset-token";
export const GET_CALCULATE_SHIPMENT_DATA =
  "common/get-data-for-calculate-shipment-price";
export const GET_QR_PICKUP_CODE = "common/get-pickup-code";
export const REGENERATE_QR_PICKUP_CODE = "common/regenerate-pickup-code";

export const EDIT_PREDELIVERY_ADDRESS =
  "shipment/edit-predelivery-address-for-shipment";
export const EDIT_PREDELIVERY_PAYMENT =
  "shipment/edit-predelivery-paytype-for-shipment";

export const SEND_PARCELS_LIST = "shipment/get-shipments-list";

export const APPLY_REFERRAL_PROGRAM = "/common/apply-referral-program";
export const GET_NEW_POST_WAREHOUSES = "dictionary/get-new-post-warehouses";
